import { createContext } from "react";

const MPremiumHistoryContext = createContext();

export default MPremiumHistoryContext;
